import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const saveView = {
  name: "saveView" as const,
  input: z.object({ view: viewSchemas["fulfillment-groups"] }),
  output: z.object({}),
};
